import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import type { RolloutDayKey } from 'fym-shared/src/music24/releaseRollout';
import { TypedMemo } from '../../../common/types';
import type { CalendarRolloutDay, CalendarSong } from '../types';
import { rolloutDayTitle } from '../releases/plan/rolloutDayCopy';
import { songColourStyle } from './calendarPostView';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface RolloutStepMarkProps {
  step: CalendarRolloutDay;
  song: CalendarSong | undefined;
}

/**
 * The rollout step of a song on a day (design a1: "7 days", "Teaser"), in the song colour. A task
 * (the Canvas mark) is a manual step, not a post, so it has a dashed box.
 */
const RolloutStepMarkComponent: React.FC<RolloutStepMarkProps> = ({ step, song }) => {
  const intl = useIntl();
  const title = rolloutDayTitle(intl, step.kind, step.dayKey as RolloutDayKey);
  const label = song === undefined ? title : `${song.title} · ${title}`;
  return (
    <span
      className={clsx(step.isTask ? styles.task : styles.mk)}
      style={songColourStyle(song)}
      title={label}
      aria-label={label}
      data-testid={`rollout-step-${step.rolloutKey}`}
    >
      {step.isTask ? <i aria-hidden="true" /> : null}
      <span>{title}</span>
    </span>
  );
};

export const RolloutStepMark = TypedMemo(RolloutStepMarkComponent);
